var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.moods),function(mood){return _c('ul',[_c('li',{on:{"click":_vm.selectMood}},[_c('img',{attrs:{"src":mood.src,"alt":mood.text}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(mood.text))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395e0d04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/moodslider.vue
// module id = null
// module chunks = 